module.exports = __webpack_public_path__ + "4b44ca560b07df644a74512cb92be833.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/power_has_a_price-768.jpg
// module id = 513
// module chunks = 0